module.exports = __webpack_public_path__ + "img/wall.7d535068.jpg";